var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"imageContainer",staticClass:"lazyImageContainer"},[(_vm.isIntersecting)?_c('img',{attrs:{"src":_vm.src,"alt":_vm.alt},on:{"load":_vm.onLoad,"error":_vm.onError}}):_c('div',{staticClass:"placeholder"})])
}
var staticRenderFns = []

export { render, staticRenderFns }